import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.damage.images');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-damage-images',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.damage.images/view.scss */
/* src/app/page.damage.images/view.scss: no such file or directory */`],
})
export class PageDamageImagesComponent implements OnInit {
    public list: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public search: any = { text: "" };
    public dragging: boolean = false;
    public uploading: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load(page: number = 1) {
        this.page = page;
        const { code, data } = await wiz.call("search", { page: this.page, dump: this.dump, text: this.search.text });
        if (code === 200) {
            this.list = data.rows;
            this.total = data.total;
        }
        await this.service.render();
    }

    public async onSearch() {
        await this.load(1);
    }

    public async uploadFiles(fileList: File[]) {
        if (!fileList || fileList.length === 0) return;
        this.uploading = true;
        await this.service.render();
        try {
            const fd = new FormData();
            for (const file of fileList) {
                fd.append("file[]", file);
            }
            const res: any = await this.service.file.upload(`/wiz/api/page.damage.images/upload`, fd);
            if (res && res.code === 200) {
                await this.load(1);
            } else {
                await this.service.modal.show({
                    title: '업로드 실패',
                    message: res?.data?.message || '이미지 업로드 중 오류가 발생했습니다.',
                    action: '확인',
                    status: 'error'
                });
            }
        } catch (e) {
            await this.service.modal.show({
                title: '업로드 실패',
                message: '서버와 통신 중 오류가 발생했습니다.',
                action: '확인',
                status: 'error'
            });
        } finally {
            this.uploading = false;
            await this.service.render();
        }
    }

    public async onUpload() {
        if (this.uploading) return;
        const files = await this.service.file.select({ accept: "image/*", multiple: true });
        if (!files || files.length === 0) return;
        await this.uploadFiles(Array.from(files));
    }

    public async onDelete(id: string) {
        const res = await this.service.modal.show({
            title: '이미지 삭제',
            message: '이미지와 관련 어노테이션이 모두 삭제됩니다. 계속하시겠습니까?',
            action: '삭제',
            status: 'error',
            actionBtn: 'error'
        });
        if (!res) return;
        await wiz.call("delete", { id });
        await this.load(this.page);
    }

    public goAnnotate(id: string) {
        this.service.href(`/damage/annotate/${id}`);
    }

    public getImageUrl(item: any) {
        return `/wiz/api/page.damage.images/image?id=${item.id}&t=${Date.now()}`;
    }

    // 드래그 앤 드롭
    public onDragOver(event: DragEvent) {
        event.preventDefault();
        this.dragging = true;
    }

    public onDragLeave(event: DragEvent) {
        this.dragging = false;
    }

    public async onDrop(event: DragEvent) {
        event.preventDefault();
        this.dragging = false;
        if (this.uploading) return;
        const files = event.dataTransfer?.files;
        if (!files || files.length === 0) return;
        const imageFiles: File[] = [];
        for (let i = 0; i < files.length; i++) {
            if (files[i].type.startsWith("image/")) imageFiles.push(files[i]);
        }
        if (imageFiles.length === 0) return;
        await this.uploadFiles(imageFiles);
    }

    public totalPages() {
        return Math.ceil(this.total / this.dump);
    }

    public pageList() {
        const pages = [];
        const total = this.totalPages();
        const start = Math.max(1, this.page - 2);
        const end = Math.min(total, this.page + 2);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }
}

export default PageDamageImagesComponent;